import { SiteMeta } from '@src/types/SiteMeta';
import { SavedSearch } from '@types';
import { currentTzString } from '@utils';
import { ReactElement } from 'react';
import { AggregationInput } from './AggregationInput';
import DateTimePicker from './DateTimePicker';
import { IntervalInputs } from './IntervalInputs';
import { checkShouldAggr } from './historianUtils';

const s = {
  gridTimeStamp: {
    alignItems: 'center',
  },
  label: {
    lineHeight: '1',
    paddingTop: 20,
  },
} as const;

interface SettingsRowProps {
  siteMeta: SiteMeta;
  timeMode: string;
  activeSearch: SavedSearch;
  setSearchField: <T>(field: string, value: T) => void;
}
function SettingsRow(props: SettingsRowProps): ReactElement {
  const { siteMeta, timeMode, activeSearch, setSearchField } = props;
  const currentTz = currentTzString({
    timeMode,
    lat: siteMeta.GPSLat,
    long: siteMeta.GPSLong,
  });
  const aggrMessage =
    !checkShouldAggr(activeSearch) && 'Displayed aggregation types';
  return (
    <>
      <div className='label' style={s.label}>
        Timestamp
        <br />
        <br />
        <span>{currentTz}</span>
      </div>
      <div className='inputs-row no-pd-top with-buttons-search'>
        <div style={s.gridTimeStamp} className='grid-timestamp'>
          <div className='small-lable'>From</div>
          <div className='small-lable' />
          <div className='small-lable'>To</div>
          <div className='small-lable pd-l'>Interval</div>
          <div className='small-lable pd-l'>{aggrMessage}</div>
          <DateTimePicker
            field='startDateTime'
            activeSearch={activeSearch}
            setSearchField={setSearchField}
          />
          <div>&nbsp;-&nbsp;</div>
          <DateTimePicker
            field='stopDateTime'
            activeSearch={activeSearch}
            setSearchField={setSearchField}
          />
          <div className='pd-l dis'>
            <IntervalInputs
              interval={activeSearch.interval}
              setSearchField={setSearchField}
              activeSearch={activeSearch}
            />
          </div>
          <div className='pd-l dis'>
            {!checkShouldAggr(activeSearch) && (
              <AggregationInput
                setSearchField={setSearchField}
                activeSearch={activeSearch}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default SettingsRow;
